'use client';

import SvgManual from '@common/icon/SvgManual';
import { cn } from '@core/utils';

import { CustomLink } from '@/app/_components/CustomLink';
import { PageNavigation } from '@/components/client';
import { DONATION_ROUTES, ROUTES } from '@/constants';
import { useCheckKakaobank } from '@/hooks/useCheckKakaobank';
import { gtmDatasets } from '@/utils/analytics/gtm';

export const DonationHomeNavigation = () => {
  const isKakaobank = useCheckKakaobank();
  const searchHref = isKakaobank
    ? DONATION_ROUTES.SEARCH.pathname
    : ROUTES.SEARCH.withSearchParams({
        searchParams: { category: 'gifts' },
      });

  return (
    <PageNavigation
      isNotUsedHomeButton
      logo="symbol"
      logoHref={DONATION_ROUTES.HOME.pathname}
      backButton={false}
      enableHistoryBack
      searchButton={searchHref}
    >
      <CustomLink
        href={DONATION_ROUTES.GUIDE.pathname}
        aria-label="고향사랑기부혜택"
        className={cn(
          'grid size-44 place-items-center rounded-pill transition-colors duration-150',
          'focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-B-500',
          'hover:bg-Gray-50 active:bg-Gray-100',
        )}
        {...gtmDatasets.clickGnb({ menu_name: '고향사랑기부혜택' })}
      >
        <SvgManual className="size-24" />
      </CustomLink>
    </PageNavigation>
  );
};
